import React, { useEffect, useState } from 'react';
import firebaseService from "../firebase.service"
import { RevolvingDot } from 'react-loader-spinner';

const ImageComponent = ({ imagePath }) => {
    const [imageUrl, setImageUrl] = useState(null);
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            try {
                let url = await firebaseService.getFileUrl(imagePath);
                
                // Mobile fallback: if URL is null or empty, try alternative approach
                if (!url && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    // Try with a small delay for mobile networks
                    await new Promise(resolve => setTimeout(resolve, 500));
                    url = await firebaseService.getFileUrl(imagePath);
                }
                
                if (url) {
                    setImageUrl(url);
                    setError(null);
                } else {
                    throw new Error("No image URL returned from Firebase Storage");
                }
            } catch (err) {
                // Mobile fallback: try image proxy
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    const proxyUrl = `${window.location.origin}/image-proxy.html?path=${encodeURIComponent(imagePath)}`;
                    setImageUrl(proxyUrl);
                    setError(null);
                } else {
                    setError(`Failed to load image: ${err.message}`);
                }
            }
        };

        fetchImage();
    }, [imagePath]);

    return (
        <div className="book-cover w-full h-full flex items-center justify-center">
            {error ? (
                <div className="flex items-center justify-center h-96 bg-gray-100 rounded-lg w-full max-w-md">
                    <div className="text-center">
                        <div className="text-red-500 text-lg mb-2">Image Load Error</div>
                        <div className="text-gray-400 text-sm">{error}</div>
                        <div className="text-gray-400 text-xs mt-2">Path: {imagePath}</div>
                    </div>
                </div>
            ) : (
                <>
                    {/* Show loader only when image URL exists but image hasn't loaded yet */}
                    {imageUrl && !isImageLoaded && (
                        <RevolvingDot
                            visible={true}
                            height="80"
                            width="80"
                            color="#4285F4"
                            ariaLabel="revolving-dot-loading"
                            wrapperStyle={{}}
                            wrapperClass="h-full flex justify-center items-center"
                        />
                    )}
                    
                    {/* Show initial loading state when no URL yet */}
                    {!imageUrl && !error && (
                        <div className="flex flex-col items-center justify-center h-96">
                            <RevolvingDot
                                visible={true}
                                height="60"
                                width="60"
                                color="#4285F4"
                                ariaLabel="loading"
                                wrapperStyle={{}}
                                wrapperClass="mb-4"
                            />
                            <div className="text-gray-500 text-sm">Loading image...</div>
                            <div className="text-gray-400 text-xs mt-2">Path: {imagePath}</div>
                        </div>
                    )}
                    
                    {/* Always render image when URL exists, but control visibility */}
                    {imageUrl && (
                        <img 
                            src={imageUrl} 
                            alt="Book cover" 
                            className="max-w-full max-h-full object-contain"
                            style={{ 
                                display: isImageLoaded ? "block" : "none", 
                                width: "auto", 
                                height: "auto", 
                                maxWidth: "100%", 
                                maxHeight: "100%",
                            }} 
                            onLoad={() => {
                                setIsImageLoaded(true);
                            }}
                            onError={(e) => {
                                setError(`Failed to load image from: ${imageUrl}`);
                            }}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ImageComponent;